module.exports = __webpack_public_path__ + "img/dy.95a4b58a.png";